export const SUB_CATEGORIES_PHONE = 20;
export const SUB_CATEGORIES_TAB = 21;
export const SUB_CATEGORIES_LAP = 20;
export const SUB_CATEGORIES_DESKTOP = 20;
